import PageWrapper from "@/components/shared/wrappers/PageWrapper";
import ErrorMain from '@/components/layout/main/ErrorMain';

export default function ErrorPage({errors, status}) {
  return (
      <PageWrapper headerStyle={2} footerBg={"dark"}>
        <ErrorMain errors={errors} status={status}/>
      </PageWrapper>
  );
};
